// extracted by mini-css-extract-plugin
export default {"wrap":"uK-z","subtitle":"vK-z","contentWrap":"wK-z","imgWrap":"xK-z","heading":"yK-z","copy":"zK-z"};